import { useTranslation } from 'react-i18next';
import { siteStats } from '@/mocks/comics';

export default function StatsSection() {
  const { t } = useTranslation();

  const stats = [
    { value: siteStats.totalComics.toLocaleString(), suffix: '+', label: t('common:stats.totalComics', '漫画总数') },
    { value: siteStats.totalChapters.toLocaleString(), suffix: '+', label: t('common:stats.totalChapters', '章节数量') },
    { value: (siteStats.activeReaders / 10000).toFixed(0) + '万', suffix: '+', label: t('common:stats.activeReaders', '活跃读者') },
    { value: siteStats.dailyUpdates.toString(), suffix: '+', label: t('common:stats.dailyUpdates', '每日更新') },
  ];

  return (
    <section className="relative bg-background-50 py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="animate-fade-in-up">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              数万读者的
              <br />
              共同选择
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              韩漫之家自成立以来，始终坚持为韩漫爱好者提供最优质的阅读体验。我们用数据证明实力，用心服务每一位读者。
            </p>
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center sm:text-left">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}<span className="text-accent-500">{stat.suffix}</span>
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden animate-slide-in-right">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-100/50 via-accent-100/30 to-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20abstract%20geometric%20shapes%20floating%20in%20warm%20pastel%20colors%2C%20rose%20gold%20and%20peach%20gradients%2C%20dreamy%20bokeh%20effect%2C%20minimalist%20composition%2C%20elegant%20flowing%20forms%2C%20delicate%20texture%2C%20clean%20modern%20aesthetic%2C%20soft%20light%20and%20air%20atmosphere%2C%20high%20quality%20abstract%20art&width=800&height=500&seq=stats-decor-2026&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}